import React from 'react';
import api from '@/utils/api';
import MfaSettingsPanel from '@/components/security/MfaSettingsPanel';

export default function AdminSecuritySettings() {
  return (
    <MfaSettingsPanel
      getStatus={() => api.get('/auth/mfa/status')}
      startEnroll={() => api.post('/auth/mfa/enroll/start')}
      verifyEnroll={(challengeId, code) => api.post('/auth/mfa/enroll/verify', { challenge_id: challengeId, code })}
      disableMfa={(currentPassword) => api.post('/auth/mfa/disable', { current_password: currentPassword })}
    />
  );
}
